import {
  DialogTitle,
  IconButton,
  DialogContent,
  List,
  ListItemText,
  DialogActions,
  Stack,
  Button,
} from "@mui/material";
import React from "react";
import { BootstrapDialog } from "../notification-modal/styles";
import { buttonColors, colors } from "../../../utility/types/constant";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";

interface CircleTermsModalProps {
  sx?: any;
  title?: string;
  open: boolean;
  onAgree: () => any;
  onDisAgree: () => any;
  handleClose: () => void;
}

const CircleTermsModal = (props: CircleTermsModalProps) => {
  const { sx, title, open, handleClose, onAgree, onDisAgree } = props;

  const handleAgree = () => {
    onAgree();
    handleClose();
  };

  const handleDisAgree = () => {
    onDisAgree();
    handleClose();
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        open={open}
        aria-labelledby="customized-dialog-title"
        sx={{
          ...sx,
          width: "80",
        }}
        fullWidth
      >
        <DialogTitle
          sx={{ m: 0, p: 2, fontSize: "1.5rem" }}
          id="customized-dialog-title"
        >
          {title}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: colors.white,
            backgroundColor: colors.cancel,
            "&:hover": {
              color: colors.white,
              backgroundColor: colors.cancel,
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers sx={{ fontSize: "1.1rem" }}>
          <List sx={{ listStyleType: "disc" }}>
            <ListItemText sx={{ display: "list-item", ml: 3 }}>
              Acceptance of Terms: By accepting to become a circle member in the
              ForUs platform , you agree to comply with the terms and conditions
              outlined in this agreement.
            </ListItemText>
            <ListItemText sx={{ display: "list-item", ml: 3 }}>
              User Responsibilities: You are responsible for maintaining the
              confidentiality of your circle information and privacy.
            </ListItemText>
            <ListItemText sx={{ display: "list-item", ml: 3 }}>
              Compliance with Laws: You agree to use your circle in the ForUs
              platform in compliance with all applicable local, state, national,
              and international laws and regulations.
            </ListItemText>
            <ListItemText sx={{ display: "list-item", ml: 3 }}>
              Financial Transactions: You acknowledge that all financial
              transactions are subject to the terms set by your circle or group
              and the platform's policies.
            </ListItemText>
            <ListItemText sx={{ display: "list-item", ml: 3 }}>
              Data Protection: Your personal information will be handled in
              accordance with our Privacy Policy.
            </ListItemText>
            <ListItemText sx={{ display: "list-item", ml: 3 }}>
              Prohibited Conduct: You agree not to engage in any activity that
              is unlawful, harmful, or in violation of community standards on
              the platform.
            </ListItemText>
            <ListItemText sx={{ display: "list-item", ml: 3 }}>
              Termination: We reserve the right to suspend or terminate your
              account for any violation of these terms.
            </ListItemText>
            <ListItemText sx={{ display: "list-item", ml: 3 }}>
              Amendments: These terms may be updated from time to time, with
              notice provided to you in accordance with our policy.
            </ListItemText>
          </List>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center" }}>
          <Stack direction="row" spacing={10}>
            <Button
              size="large"
              onClick={handleAgree}
              variant="contained"
              sx={{
                bgcolor: buttonColors.secondPrimary,
                color: colors.white,
                "&:hover": {
                  bgcolor: buttonColors.secondPrimary,
                  color: colors.white,
                },
              }}
            >
              Agree
            </Button>

            <Button
              size="large"
              onClick={handleDisAgree}
              variant="contained"
              sx={{
                bgcolor: buttonColors.persianRed,
                color: colors.white,
                "&:hover": {
                  bgcolor: buttonColors.persianRed,
                  color: colors.white,
                },
              }}
            >
              Disagree
            </Button>
          </Stack>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};

CircleTermsModal.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  sx: PropTypes.any,
  onAgree: PropTypes.func.isRequired,
  onDisAgree: PropTypes.func.isRequired,
};

export default CircleTermsModal;
